module.exports = __webpack_public_path__ + "img/emagister.6ce487f0.png";